import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 51
class PrintReportJobCostSheet extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.criterion!=undefined) {
            ReportStore.loadReportJobCostSheetWork(this.props.year,this.props.month,this.props.day,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.criterion!=undefined) {
            ReportStore.loadReportJobCostSheetWorkRange(this.props.startDate,this.props.endDate,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
      }
    
    getPercentSummary(field,field1) {
        let {data} = this.state
        let total = 0
        let total1 = 0
        let sum = 0
        data.forEach((item,index)=> {
          total = (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
          total1 = (item[field1]===''||item[field1]===null||item[field1]===undefined||isNaN(item[field1])?0:item[field1]*1)
          sum += this.getPercent(total,total1)
        })
        return sum
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    getPercent(cost,value) {
        let sum = 0
        if (value>0)
          sum = (cost/value)*100
        return sum
    }

    renderRowData(data,indexs) {
        let {criterion} = this.props
        if (data.length==0) {
          return(<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
                <td className='text-center'>{(indexs*50)+index+1}</td>
                <td className='text-center'>{item.work_no}</td>
                <td className='text-center'>{item.car_registration_no}</td>
                <td className='text-right'>{this.getNumberFormat(item.quotation_amount)}</td>
                <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
                <td className='text-right'>{this.getNumberFormat(item.cost_supply1)}</td>
                <td className='text-right'>{this.getNumberFormat(item.cost_supply2)}</td>
                <td className='text-right'>{this.getNumberFormat(item.cost_part)}</td>
                <td className={'text-right'+(this.getPercent(item.cost_supply,item.quotation_amount)>criterion?' color-red':'')}>{this.getNumberFormat(this.getPercent(item.cost_supply,item.quotation_amount))}</td>
                <td className={'text-right'+(this.getPercent(item.cost_supply,item.approved_amount)>criterion?' color-red':'')}>{this.getNumberFormat(this.getPercent(item.cost_supply,item.approved_amount))}</td>
                <td className={'text-right'+(this.getPercent(item.cost_part,item.quotation_amount)>criterion?' color-red':'')}>{this.getNumberFormat(this.getPercent(item.cost_part,item.quotation_amount))}</td>
                <td className={'text-right'+(this.getPercent(item.cost_part,item.approved_amount)>criterion?' color-red':'')}>{this.getNumberFormat(this.getPercent(item.cost_part,item.approved_amount))}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-analysis'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'100px'}}>เลขที่งานซ่อม</td>
                        <td className='text-center' style={{width:'110px'}}>ทะเบียน</td>
                        <td className='text-center' style={{width:'90px'}}>ราคาเสนอ</td>
                        <td className='text-center' style={{width:'90px'}}>ราคาอนุมัติ</td>
                        <td className='text-center' style={{width:'120px'}}>ต้นทุน<br/>ค่าเบ็ตเตล็ด</td>
                        <td className='text-center' style={{width:'120px'}}>ต้นทุน<br/>ค่าสี</td>
                        <td className='text-center' style={{width:'100px'}}>ต้นทุน<br/>ค่าอะไหล่</td>
                        <td className='text-center' style={{width:'100px'}}>%วัสดุ/<br/>ราคาเสนอ</td>
                        <td className='text-center' style={{width:'100px'}}>%วัสดุ/<br/>ราคาอนุมัติ</td>
                        <td className='text-center' style={{width:'100px'}}>%ค่าอะไหล่/<br/>ราคาเสนอ</td>
                        <td className='text-center' style={{width:'100px'}}>%ค่าอะไหล่/<br/>ราคาอนุมัติ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={3} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('quotation_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_supply1'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_supply2'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_part'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getPercentSummary('cost_supply','quotation_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getPercentSummary('cost_supply','approved_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getPercentSummary('cost_part','quotation_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getPercentSummary('cost_part','approved_amount'))}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportJobCostSheet.defaultProps = {
    title: 'ตารางรายงาน Job Cost Sheet',  
    mode: '',
    workNo: ''
  }
  export default PrintReportJobCostSheet;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportJobCostSheet.js